import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import BlanksFilterRenderer from '_legacy/components/grid/renderers/BlanksFilterRenderer';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';

const getDualFuelDisplayValue = (
    alternativeFuelType: string | null | undefined
): string => {
    if (!alternativeFuelType) {
        return '';
    }
    if (
        alternativeFuelType === 'Biofuel' ||
        alternativeFuelType === 'Biofuels'
    ) {
        return 'Conventional';
    }
    return alternativeFuelType;
};

const vesselDualFuelHeading = {
    colId: 'dualFuel',
    headerName: 'Dual-Fuel',
    field: 'vessel.alternativeFuelType',
    editable: false,
    valueGetter: (params: any) =>
        getDualFuelDisplayValue(params.data?.vessel?.alternativeFuelType),
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    width: 120,
    hide: true,
};

export default vesselDualFuelHeading;
